const getArticlePayload = (article) => ({
  slug: article.slug,
  title: article.title,
  is_pro_team_page: article.isProTeamPage,
  category: article.category.slug,
})

export default (tracker) => ({
  async viewArticle(article) {
    await tracker.track('Explore Article Viewed', getArticlePayload(article))
  },

  async viewAthlete(athlete) {
    await tracker.track('Explore Athlete Viewed', getArticlePayload(athlete))
  },
})
